<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Open Space Technology</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="titlepage">
<a id="pageiii">
<h1 class="title">OPEN SPACE <br/>TECHNOLOGY </h1>
<h1 class="subtitle">A User’s Guide <br/><b><span class="small">Third Edition</span> </b><br/><br/><br/><br/><br/><br/></h1>
<h2 class="author">HARRISON OWEN </h2>
<div class="image">
<img alt="9781576757758_WEB_0004_001" src="images/9781576757758_WEB_0004_001.jpg"/>
</div>
</a></div><a id="pageiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?0a90d1fa